import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';
import React from 'react';
import { IConfirmationDialogProps } from './ConfirmationDialog';

const ConfirmationDialogView: React.FC<IConfirmationDialogProps> = (props) => {
    const { title, desc, onConfirm, onDismiss, target, isOpen, confirmText, cancelText } = props;

    const dialogContentProps = {
        type: DialogType.normal,
        title: title,
        closeButtonAriaLabel: IvicosStrings.closeActionTitle,
        subText: desc
    };

    return (
        <>
            {isOpen && (
                <Dialog hidden={false} onDismiss={() => onDismiss(target)} dialogContentProps={dialogContentProps}>
                    <DialogFooter>
                        <DefaultButton onClick={() => onDismiss(target)} text={cancelText || IvicosStrings.closeActionTitle} />
                        <PrimaryButton onClick={() => onConfirm(target)} text={confirmText || IvicosStrings.confirmActionTitle} />
                    </DialogFooter>
                </Dialog>
            )}
        </>
    );
};

export default ConfirmationDialogView;
